// extracted by mini-css-extract-plugin
export default {"container":"uMvXG","toggle":"qHbud","input":"dn5Xs","checkbox":"bgJGC","disabledCheckbox":"_C8Lr","disabledTextBar":"FpHZ9"};